import { FC, ReactNode } from "react";

import gridStyles from "../styles/Grid.module.css";

export interface HeaderBarPartProps {
  justifyContent?: string;
  size?: number;
  children: ReactNode;
}

const HeaderBarPart: FC<HeaderBarPartProps> = ({ children, justifyContent, size = 4 }) => {
  return (
    <div
      style={{
        height: "76px",
        display: "flex",
        alignItems: "center",
        gap: "2rem",
        justifyContent,
      }}
      className={`${gridStyles["colLg" + size]} ${gridStyles["colMd" + size]} ${
        gridStyles["colSm" + size]
      } ${gridStyles.colXs12}`}
    >
      {children}
    </div>
  );
};

export default HeaderBarPart;
